import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "portfolio-view" }
const _hoisted_2 = { class: "content-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_NavIsland = _resolveComponent("NavIsland")!
  const _component_PortfolioComponent = _resolveComponent("PortfolioComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavBar),
    _createVNode(_component_NavIsland),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_component_PortfolioComponent)
    ])
  ]))
}